import React, { Fragment } from 'react'
import ScreenIcon from '../Icons/ScreenIcon'

const DoanNavLogo = (props) => {
  return(
    <Fragment>
      <span className={props.width < 480 ? 'small-navFont' : 'navFont'} style={{color:'#F5F5FC'}}>
        <span style={{paddingRight:'.25em'}}>
          {(window.location.pathname !== '/' || (window.location.pathname === '/' && props.width < 992)) && 
            <ScreenIcon 
              height={
                props.width < 480 ? '.8em' : '1.1em'
              } 
              width={
                props.width < 480 ? '.8em' : '1.1em'
              } 
              fill='#00e5ff'/>
          }
        </span>Doan
      </span> 
    </Fragment>
  )
}

export default DoanNavLogo